import script from "./pie-center.vue?vue&type=script&lang=ts&setup=true"
export * from "./pie-center.vue?vue&type=script&lang=ts&setup=true"

import "./pie-center.vue?vue&type=style&index=0&id=7d84484a&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d84484a"]])

export default __exports__